import { EStatus } from 'shared/types/form';
import { TApplicationState } from 'shared/types/redux';

export const selectFormStatus = (state: TApplicationState): EStatus => {
  return state.formStatus.status;
};
